module.exports = [{"name":"创建时间","code":"0"},{"name":"开始时间","code":"1"},{"name":"结束时间","code":"2"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/timeType.json
// module id = gmbb
// module chunks = 11